import { CommonPageALMeta } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { $PageLevelTraffic } from 'shared/atoms';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { useCompletedActiveSchema } from '~/utils/active/use-completed-active-schema';
import { useParams } from '@remix-run/react';

export const PoiFacebookALMeta = () => {
  const getSchemaOption: () => DeepLinkBuildingProps = () => {
    const { poi_id: poiId = '' } = useParams<{ poi_id: string }>();
    const schemaOption: DeepLinkBuildingProps = useMemo(() => {
      if (!poiId) {
        return { pageType: 'feed', categoryId: 0 };
      }

      return { pageType: 'poi', poiId };
    }, []);
    return schemaOption;
  };
  const schemaOption = getSchemaOption();

  const alMetaInfo = {
    openUrl: useCompletedActiveSchema(
      {
        ...schemaOption,
        pid: 'seo_al_fb',
      },
      {
        enterPosition: 'seo_al_fb',
      },
    ),
    webUrl: useAtomValue($PageLevelTraffic).canonicalUrl,
  };

  return <CommonPageALMeta {...alMetaInfo} />;
};
